import React, { useEffect, useRef, useState } from "react";
import "datatables.net-dt";
import "datatables.net-responsive-dt";
import $ from "jquery";
import { Link } from "react-router-dom";
// import DeleteModel from "../../../components/admin/DeleteModel";
import api from "../../../config/URL";
import ImageURL from "../../../config/ImageURL";

const Products = () => {
  const tableRef = useRef(null);
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(false);

  const initializeDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      return;
    }
    $(tableRef.current).DataTable({
      columnDefs: [{ orderable: false, targets: -1 }],
    });
  };

  useEffect(() => {
    if (!loading) {
      initializeDataTable();
    }
    return () => {
      destroyDataTable();
    };
  }, [loading]);

  const destroyDataTable = () => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
  };

  const refreshData = async () => {
    destroyDataTable();
    setLoading(true);
    try {
      const response = await api.get("/admin/products");
      setDatas(response.data.data);
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
    setLoading(false);
    initializeDataTable();
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await api.get("/admin/products");
        setDatas(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setLoading(false);
      initializeDataTable();
    };
    fetchData();
    refreshData();

    return () => {
      destroyDataTable();
      fetchData();
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <section className="px-4">
      <div className="card shadow border-0 mb-2 top-header">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col p-2">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0 ls-tight">Deals</h3>
                <span className="gap-2">
                  <Link to="/products/topdeal">
                    <button className="btn btn-sm me-2 btn-button shadow-none border-0">
                      Top Deals
                    </button>
                  </Link>
                  <Link to="/products/order">
                    <button className="btn btn-sm btn-button shadow-none border-0">
                      Select Order
                    </button>
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="container card shadow border-0"
        style={{ minHeight: "80vh" }}
      >
        {loading ? (
          <div className="loader-container">
            <div className="loader">
              <svg viewBox="0 0 80 80">
                <circle cx="40" cy="40" r="32"></circle>
              </svg>
            </div>
          </div>
        ) : (
          <div className="table-responsive p-2">
            <table
              ref={tableRef}
              className="display table nowrap"
              style={{ width: "100%" }}
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col" style={{ whiteSpace: "nowrap" }}>
                    S.NO
                  </th>
                  <th className="text-start">Title</th>
                  <th className="text-start">Orginal Price</th>
                  <th className="text-start">Discounted Price</th>
                  <th className="text-start">Company Name</th>
                  <th className="text-start">Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {datas?.map((data, index) => (
                  <tr key={data.id}>
                    <td className="text-start align-middle">{index + 1}</td>
                    <td className="text-start">
                      {/* <img
                        src={`${ImageURL}${data.image_url1}`}
                        alt="Logo"
                        className="img-fluid w-25 me-3"
                        style={{ maxHeight: "70px", maxWidth: "70px" }}
                      /> */}
                      {data?.shop?.is_direct === 1 ? (
                        data?.special_price === 1 &&
                        new Date(data?.end_date) > new Date() ? (
                          <>
                            <span
                              className="dot"
                              style={{
                                backgroundColor: "#3598f0",
                                width: "10px",
                                height: "10px",
                                display: "inline-block",
                                borderRadius: "50%",
                                marginRight: "3px",
                              }}
                            ></span>
                          </>
                        ) : null
                      ) : (
                        <></>
                      )}{" "}
                      {data?.name}
                    </td>
                    <td className="align-middle text-start">
                      {data?.original_price &&
                        new Intl.NumberFormat("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                          useGrouping: true,
                        }).format(parseFloat(data?.original_price))}
                    </td>
                    <td className="align-middle text-start">
                      {data?.discounted_price &&
                        new Intl.NumberFormat("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                          useGrouping: true,
                        }).format(parseFloat(data?.discounted_price))}
                    </td>
                    <td className="align-middle text-start">
                      {data?.shop?.legal_name}
                    </td>
                    <td className="align-middle text-start">
                      {data.active === 1 ? (
                        <>
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "green",
                              width: "10px",
                              height: "10px",
                              display: "inline-block",
                              borderRadius: "50%",
                              marginRight: "3px",
                            }}
                          ></span>
                          Active
                        </>
                      ) : (
                        <>
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "red",
                              width: "10px",
                              height: "10px",
                              display: "inline-block",
                              borderRadius: "50%",
                              marginRight: "3px",
                            }}
                          ></span>
                          Inactive
                        </>
                      )}
                    </td>
                    <td className="align-middle text-center">
                      <Link to={`/products/view/${data.id}`}>
                        <button className="button-btn btn-sm m-2">View</button>
                      </Link>
                      {/* <DeleteModel /> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default Products;
